const initialState = {
  visible: false,
};

const modalSurchargeServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SHOW_MODAL_SURCHARGE_SERVICE": {
      return {
        visible: true,
      };
    }

    case "CLOSE_MODAL_SURCHARGE_SERVICE": {
      return {
        visible: false,
      };
    }

    default:
      return state;
  }
};

export default modalSurchargeServiceReducer;
